import React from 'react';

const MessageCardSkeleton: React.FC = () => (
    <>
        {/* Incoming message skeleton */}
        <li className="flex gap-3 max-w-[50%] mt-4">
            <div className="w-7 h-7 rounded-full bg-utilityGray200 animate-pulse flex-none mt-4" />
            <div className="flex flex-col gap-1.5">
                <div className="h-3 w-24 bg-utilityGray200 animate-pulse rounded" />
                <div className="h-9 w-48 bg-utilityGray200 animate-pulse rounded-lg rounded-tl-none" />
            </div>
        </li>

        {/* Outgoing message skeleton */}
        <li className="flex justify-end mt-4">
            <div className="flex flex-col gap-1.5 items-end">
                <div className="h-3 w-16 bg-utilityGray200 animate-pulse rounded" />
                <div className="h-9 w-56 bg-utilityGray200 animate-pulse rounded-lg rounded-tr-none" />
            </div>
        </li>

        {/* Incoming message skeleton (shorter) */}
        <li className="flex gap-3 max-w-[50%] mt-1">
            <div className="w-7 flex-none" />
            <div className="h-9 w-36 bg-utilityGray200 animate-pulse rounded-lg rounded-tl-none" />
        </li>

        {/* Outgoing message skeleton */}
        <li className="flex justify-end mt-4">
            <div className="flex flex-col gap-1.5 items-end">
                <div className="h-3 w-16 bg-utilityGray200 animate-pulse rounded" />
                <div className="h-9 w-40 bg-utilityGray200 animate-pulse rounded-lg rounded-tr-none" />
            </div>
        </li>
    </>
);

export default MessageCardSkeleton;
